const filenamePart = (value: string) => value.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9-]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 60) || "Business";

export function documentPdfFilename(kind: "invoice" | "estimate", number: string | null | undefined): string {
  return `${kind === "invoice" ? "Invoice" : "Estimate"}-${filenamePart(number ?? "Draft")}.pdf`;
}
